import React from 'react';
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";

const Mission = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.Mission[key][currentLang];

  return (
    <section className='grid'>
      <div className="contentfront">
        <div className="page-content mission-page">
          <h1>{t("title")}</h1>

          <p>{t("intro1")}</p>
          <p>{t("intro2")}</p>

          <div className="highlight-box">
            <h2>{t("beliefsTitle")}</h2>
            <ul className="styled-bullets">
  <li>🎯 {t("belief1")}</li>
  <li>🤝 {t("belief2")}</li>
  <li>⭐️ {t("belief3")}</li>
</ul>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
